// ui/stuck-dealer-caption.js: one tested stuck-dealer caption.
//
// The caption the stuck dealer sees ("Stick the dealer: call a suit")
// and its condition live here together so the unit test pins both.
// BiddingControls imports this; no other copy of the string or the
// condition exists.

export const STUCK_DEALER_CAPTION = 'Stick the dealer: call a suit';

/**
 * The stuck-dealer caption when the viewer must call, else null. Same
 * shape as ui/bidding-logic.js isDealerLastR2 (round 2, viewer deals,
 * stick on, three prior round-2 passes already in): Pass is missing
 * for a reason.
 *
 * @param {any} gameState
 * @param {number} myLuaSeat
 * @returns {string|null}
 */
export function stuckDealerCaption(gameState, myLuaSeat) {
  if (!gameState?.stick_the_dealer) return null;
  if (gameState.current_state !== 'bid_r2') return null;
  if (gameState.dealer_seat !== myLuaSeat) return null;
  const history = Array.isArray(gameState.bid_history)
    ? gameState.bid_history
    : Object.values(gameState.bid_history || {});
  if (history.filter((b) => b && b.round === 2 && b.action === 'pass').length < 3) return null;
  return STUCK_DEALER_CAPTION;
}
